import { CoreSubstatus } from "@tc/graphql-server"

export interface SubstatusLabel {
  value: (substatus: CoreSubstatus) => string
}

// DFE substatus label mapping - used on list view page
export const substatus_label: Record<CoreSubstatus, string> = {
  [CoreSubstatus.PendingSfCall]: "Pending SF call",
  [CoreSubstatus.PendingVerification]: "Pending verification",
  [CoreSubstatus.PendingCertification]: "Pending certification",
}

const createSubstatusLabel = (
  mapping: Record<CoreSubstatus, string>,
): SubstatusLabel => ({
  value: (substatus: CoreSubstatus) => mapping[substatus],
})

export const defaultSubstatusLabel = createSubstatusLabel(substatus_label)
